import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, isNullOrEmpty, closeCollapsible, downloadFile } from '../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { Input, BackButton, Button, Title, Select, SelectItem } from '../../../components/UI/ComponentsUI';
import LogListItem from './LogListItem'
import { setSelectedLog } from '../../../actions/logAction';
import InfiniteScrollUl from '../../../components/UI/InfiniteScrollUl';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import CollapsibleUI from '../../../components/UI/CollapsibleUI';
import LoadUnloadService from '../../../services/LoadUnloadService';

const LogList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [logs, setLogs] = useState([]);
    const [filter, setFilter] = useState(
        {
            mvmNumber: undefined,
            supplier: undefined,
            mdrType: undefined,
            createdBy: undefined,
            initialDate: undefined,
            finalDate: undefined,
            jsonRequest: undefined,
            loadUnload: true
        });


    useEffect(() => {
        setFilter(props.filter);
        props.loadSheds();

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.logs?.items?.length > 0) {
            if (logs.length > 0 && currentPage === 0) {
                setLogs([...props.logs.items]);
            } else {
                setLogs((prevState) => ([...prevState, ...props.logs.items]));
            }
        } else {
            setLogs([]);
        }
        // eslint-disable-next-line
    }, [props?.logs?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onClick();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeSelectItem = (event) => {
        filter.createdBy = event;
        setFilter(filter);
    };

    const onClick = () => {
        filter.loadUnload = true;
        props.setFilter(filter);
        if (validateInputsRequired("formLog")) {
            props.getLogs(Object.assign(filter, {
                PageSize: 25,
                PageIndex: currentPage
            }), () => {
                closeCollapsible("filterLogs");
            })
        }
    }

    const exportExcel = () => {
        filter.loadUnload = true;
        props.setFilter(filter);
        if (validateInputsRequired("formLog")) {
            props.export(Object.assign(filter), (data) => {
                downloadFile(data, `Logs${Date.now()}.csv`, "data:text/csv", false);
            })
        }
    }

    const onClickItem = (item) => {
        props.setSelectedLog(item);
        props.history.push('/loadunload/logs/logdetails');
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-list-outline" label="Logs" />
                </div>
            </div>
            <div className="title" style={{ float: 'right', margin: '10px' }}>
                <i className="mdi mdi-24px mdi-file-excel" style={{ cursor: 'pointer' }} onClick={() => exportExcel()}></i>
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <CollapsibleUI
                        id="filterLogs"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <div className="row">
                                <div className="input-field no-padding col s6">
                                    <Input
                                        defaultValue={filter.initialDate}
                                        type="date"
                                        label={translate('change-location:startDate')}
                                        id="initialDate"
                                        name="initialDate"
                                        // required={requiredDate()}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        defaultValue={filter.finalDate}
                                        type="date"
                                        label={translate('change-location:endDate')}
                                        id="finalDate"
                                        name="finalDate"
                                        // required={requiredDate()}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        id="mvmNumber"
                                        name='mvmNumber'

                                        label={translate('mvm', 'physical-confirmation')}
                                        type="text"
                                        defaultValue={filter?.mvmNumber || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <SelectItem

                                        label={translate('login.username')}
                                        id="userName"
                                        name="userName"
                                        value={filter.userName}
                                        onChange={(event) => onChangeSelectItem(event)}
                                        onChangeData={onChangeSelectItem}
                                        data={props.usersFromElog ? props.usersFromElog.map(item => {
                                            return {
                                                id: item.id,
                                                text: item.user
                                            }
                                        }) : []}
                                    />
                                </div>

                            </div>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button
                            full="true"
                            text="Buscar"
                            onClick={() => onClick()}
                        />
                    </div>

                </div>
                <InfiniteScrollUl
                    page={props.logs?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.logs?.totalPages}
                    data={logs.map((item) => {
                        return <LogListItem
                            sheds={props.sheds}
                            key={`key_${item.logId}`}
                            onClickItem={item => onClickItem(item)}
                            item={item} />
                    })}
                />
            </div>
        </div>
    );
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        logs: state.logReducer.logs,
        filter: state.physicalConfirmationReducer.filter,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog),
        sheds: state.loadUnloadReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLogs: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getLogs(filter, callback));
        },
        export: (filter, callback) => {
            dispatch(PhysicalConfirmationService.ExportLogs(filter, callback));
        },
        setSelectedLog: (log) => {
            dispatch(setSelectedLog(log));
        },
        setFilter: (filter) => {
            dispatch(PhysicalConfirmationService.setFilter(filter));
        },
        loadSheds: (callback) => {
            dispatch(LoadUnloadService.getShedsLoad(callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogList)));
